module.exports = __webpack_public_path__ + "img/IchHabeEineBanane.de572d9a.svg";